export const SDK_VERSION = '7.34.0';
